import { ByStatusDetail, HangingIncomingSummary, SubmitHangingConfirmationFollowUp, SubmitHangingConfirmationUpdateStatus, RiwayatHangingLasmileEntities, ListRiwayatHangingLasmile, HangingIncoming, FollowUpInfo, FollowUpGroup, GroupSummary, AWB, AWBSummary, FollowUpSTT, HistoryFollowUpIncomingEntities, HistoryFollowUpIncoming, FollowUpDetail, ActivitiesDetail, HistoryHangingIncomingEntities, HistoryHangingIncoming, HangingIncomingUpdateStatus } from "@/domain/entities/HangingIncoming";
import { AxiosResponse } from "axios";
import { Pagination } from "@/domain/entities/Pagination";
import { HistoryFollowUpOutgoingEntities, HistoryFollowUpOutgoing, FollowUpOutgoing, ActivitiesFollowUpOutgoing } from '@/domain/entities/HangingOutgoing';

export class HangingIncomingMapper {

  public convertHangingIncomingSummaryFromApi(res: AxiosResponse<any>): HangingIncomingSummary {
    const {
      data: { data }
    } = res;
    return new HangingIncomingSummary({
      lastSync: data.last_sync,
      activitiesPending: data.activities_pending,
      activitiesDone: data.activities_done,
      totalActivities: data.total_activities,
      awbHangingPending: data.awb_hanging_pending,
      awbHangingDone: data.awb_hanging_done,
      totalAwbHanging: data.total_awb_hanging,
      bagHangingPending: data.bag_hanging_pending,
      bagHangingDone: data.bag_hanging_done,
      totalBagHanging: data.total_bag_hanging,
      sttHangingPending: data.stt_hanging_pending,
      sttHangingDone: data.stt_hanging_done,
      totalSttHanging: data.total_stt_hanging,
      byStatus: data.by_status.map((status: any) => new ByStatusDetail({
        awb: status.awb,
        status: status.status,
        totalBag: status.total_bag,
        totalStt: status.total_stt
      })),
    });
  }

  public convertSubmitHangingConfirmationFollowUpResponse(res: AxiosResponse<any>): SubmitHangingConfirmationFollowUp {
    const {
      data: {data}
    } = res;

    return new SubmitHangingConfirmationFollowUp({
      success: data.status,
      message: {
        en: data.message.en,
        id: data.message.id,
      },
      data: {
        activityId: data.data.activity_id,
        statusFollowUp: data.data.status_follow_up,
        confirmedAt: data.data.confirmed_at
      }
    })
  }

  public convertSubmitHangingConfirmationUpdateStatusResponse(res: AxiosResponse<any>): SubmitHangingConfirmationUpdateStatus {
    const {
      data: {data}
    } = res;

    return new SubmitHangingConfirmationUpdateStatus({
      success: data.status,
      message: {
        en: data.message.en,
        id: data.message.id,
      },
      data: {
        activityId: data.data.activity_id,
        statusFollowUp: data.data.status_follow_up,
        confirmedAt: data.data.confirmed_at
      }
    })
  }

  public convertHangingIncomingRiwayatLasymileFromApi(res: AxiosResponse<any>): RiwayatHangingLasmileEntities {
    const { data } = res;
    return new RiwayatHangingLasmileEntities(
      new Pagination(data.meta.page, data.meta.limit, data.meta.total_records),
      data.data.length
        ? data.data.map(
            (item: any) =>
              new ListRiwayatHangingLasmile({
                manifestNo: item.manifest_no,
                sttNo: item.stt_no,
                aggregator: item.aggregator,
                hangingDays: item.hanging_days,
                existenceStatus: item.existence_status,
                existenceLocation: item.existence_location,
                existenceUsername: item.existence_username,
                existenceFindAt: item.existence_find_at,
                status: item.status,
                username: item.username,
                createdAt: item.created_at,
              })
          )
        : []
    );
  }



  public convertHangingIncomingListFromApi(res: AxiosResponse<any>): HangingIncoming[] {
    const { data } = res;
    return data.data.length ? data.data.map((item: any) => 
      new HangingIncoming({
        activityId: item.activity_id,
        activityType: item.activity_type,
        followUpStatus: item.follow_up_status,
        followUpByUsername: item.follow_up_by_username,
        followUpAt: item.follow_up_at,
        followUp: new FollowUpInfo({
          courierName: item.follow_up?.courier_name,
          courierPhone: item.follow_up?.courier_phone,
          username: item.follow_up?.username,
          origin3lc: item.follow_up?.origin_3lc,
          originName: item.follow_up?.origin_name
        }),
        groups: (item.groups || []).map((group: any) => new FollowUpGroup({
          groupName: group.group_name,
          summary: new GroupSummary({
            totalAwb: group.summary?.total_awb,
            totalOrigin: group.summary?.total_origin,
            totalPiece: group.summary?.total_piece,
            totalBag: group.summary?.total_bag,
            totalStt: group.summary?.total_stt
          }),
          awbs: (group.awbs || []).map((awb: any) => new AWB({
            awbNo: awb.awb_no,
            origin3lc: awb.origin_3lc,
            originName: awb.origin_name,
            arrivedAt: awb.arrived_at,
            summary: new AWBSummary({
              bag: awb.summary?.bag,
              stt: awb.summary?.stt
            }),
            stts: (awb.stts || []).map((stt: any) => new FollowUpSTT({
              no: stt.no,
              bagNo: stt.bag_no,
              sttNo: stt.stt_no,
              isAggregator: stt.is_aggregator,
              hangingDays: stt.hanging_days,
              existenceStatus: stt.existence_status,
              existenceLocation: stt.existence_location,
              existenceUsername: stt.existence_username,
              existenceFindAt: stt.existence_find_at
            }))
          }))
        }))
      })
    ) : []
  }

  public convertHistoryFollowUpIncomingFromApi(res: AxiosResponse<any>): HistoryFollowUpIncomingEntities {
    const { data } = res;

    return new HistoryFollowUpIncomingEntities(
      new Pagination(data.meta.page, data.meta.limit, data.meta.total_records),
      (data.data || []).map(
        (item: any) =>
          new HistoryFollowUpIncoming({
            date: item.date,
            activities: (item.activities || []).map(
              (activitie: any) =>
                new ActivitiesDetail({
                  activityId: activitie.activity_id,
                  activityType: activitie.activity_type,
                  statusFollowUp: activitie.status_follow_up,
                  followUp: new FollowUpDetail({
                    courierName: activitie.follow_up?.courier_name || "",
                    courierPhone: activitie.follow_up?.courier_phone || "",
                    username: activitie.follow_up?.username || "",
                    origin3lc: activitie.follow_up?.origin_3lc || "",
                    originName: activitie.follow_up?.origin_name || "",
                  }),
                  username: activitie.username,
                  createdAt: activitie.created_at,
                })
            ),
          })
      )
    );
  }
  
  public convertHistoryHangingIncomingListFromApi(res: AxiosResponse<any>): HistoryHangingIncomingEntities {
    const { data } = res;
    return new HistoryHangingIncomingEntities({
      pagination: new Pagination(
        data.meta.page,
        data.meta.limit,
        data.meta.total_records
      ),
      data: data.data.length ? data.data.map((item: any) => 
        new HistoryHangingIncoming({
          awbNo: item.awb_no,
          bagNo: item.bag_no,
          sttNo: item.stt_no,
          aggregator: item.aggregator,
          hangingDays: item.hanging_days,
          existenceStatus: item.existence_status,
          existenceLocation: item.existence_location,
          existenceUsername: item.existence_username,
          existenceFindAt: item.existence_find_at,
          status: item.status,
          username: item.username,
          createdAt: item.created_at
        })
      ) : []
    })
  }

  public convertHangingIncomingUpdateStatusResponse(res: AxiosResponse<any>): HangingIncomingUpdateStatus {
    const {
      data: {data}
    } = res;

    return new HangingIncomingUpdateStatus({
        customProcessId: data.custom_process_id,
        totalSttFailed: data.total_stt_failed,
        totalSttSuccess: data.total_stt_success
      })
  }

  public convertHistoryFollowUpOutgoingFromApi(res: AxiosResponse<any>): HistoryFollowUpOutgoingEntities {
    const { data } = res;

    return new HistoryFollowUpOutgoingEntities(
      {
        pagination: new Pagination(data.meta.page, data.meta.limit, data.meta.total_records),
        data: (data.data || []).map(
          (item: any) =>
            new HistoryFollowUpOutgoing({
              date: item.date,
              activities: (item.activities || []).map(
                (activity: any) =>
                  new ActivitiesFollowUpOutgoing({
                    activityId: activity.activity_id,
                    activityType: activity.activity_type,
                    statusFollowUp: activity.status_follow_up,
                    followUp: new FollowUpOutgoing({
                      opsUsername: activity.follow_up?.ops_username || ""
                    }),
                    username: activity.username,
                    createdAt: activity.created_at,
                  })
              ),
            })
        )
      }
    );
  }
}
